/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Interaction from 'astro/server/interaction';

import * as Coords from 'shared/geo/coords';


export default class extends Interaction
{
  installTargetPlanet (planet)
  {
    const target = planet.getZones().getOne(this.cass.target.id);

    target.getAttributes().setInfluenceDisables(this.getDisabledLocations());
  }


  installSourcePlanet (planet)
  {
    // no-op.
  }


  getDisabledLocations ()
  {
    let collection = [];

    for (const coords of Coords.getNeighborsInRing(this.cass.target.id))
    {
      collection.push({ id: coords.toString(), parent: this.cass.target.parent });
    }

    return collection;
  }


  isAggressive ()
  {
    return true;
  }


};
